import React, { useEffect, useState } from "react";
import { apiGet } from "../../../utils/api_service";
import endpoint from "../../../config/endpoints";

export default function TopSalesPerformers() {
  const [loading, setLoading] = useState(true);

  const [selectedUser, setSelectedUser] = useState(null);

  const [data, setData] = useState([
    {
      id: 1,
      name: "Rahul Sharma",
      designation: "Area Sales Manager",
      role: "ASM",
      region: "West India",
      joiningDate: "12 Jan 2021",
      employeeCode: "EMP1021",
      sales: 248000,
      growth: 18,
      target: 92,
      phone: "+91 9876543210",
      email: "rahul.sharma@company.com",
      avatar: "RS",
    },

    {
      id: 2,
      name: "Amit Verma",
      designation: "Regional Sales Manager",
      role: "RSM",
      region: "North India",
      joiningDate: "04 Aug 2020",
      employeeCode: "EMP1022",
      sales: 224000,
      growth: 14,
      target: 88,
      phone: "+91 9876543211",
      email: "amit.verma@company.com",
      avatar: "AV",
    },

    {
      id: 3,
      name: "Sneha Patil",
      designation: "Sales Officer",
      role: "SO",
      region: "West India",
      joiningDate: "18 Mar 2022",
      employeeCode: "EMP1023",
      sales: 212000,
      growth: 11,
      target: 84,
      phone: "+91 9876543212",
      email: "sneha.patil@company.com",
      avatar: "SP",
    },

    {
      id: 4,
      name: "Vikas Gupta",
      designation: "Territory Sales Incharge",
      role: "TSI",
      region: "South India",
      joiningDate: "22 Sep 2021",
      employeeCode: "EMP1024",
      sales: 198000,
      growth: 9,
      target: 81,
      phone: "+91 9876543213",
      email: "vikas.gupta@company.com",
      avatar: "VG",
    },

    {
      id: 5,
      name: "Neha Joshi",
      designation: "Sales Officer",
      role: "SO",
      region: "East India",
      joiningDate: "09 Jun 2023",
      employeeCode: "EMP1025",
      sales: 191000,
      growth: 7,
      target: 79,
      phone: "+91 9876543214",
      email: "neha.joshi@company.com",
      avatar: "NJ",
    },
  ]);

  /* -------------------------------------------------------------------------- */
  /*                               Fake API Delay                               */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    apiGet({
      url: endpoint.salesExecutive + "/get-sales-person-by-areas-optimize",
    }).then(({ data, success }) => {
      setLoading(false);
      console.log(data);
    });
  }, []);

  /* -------------------------------------------------------------------------- */
  /*                                   Loader                                   */
  /* -------------------------------------------------------------------------- */

  if (loading) {
    return <TopSalesPerformersSkeleton />;
  }

  return (
    <>
      {/* Shimmer */}

      <style>
        {`
          @keyframes shimmer {
            0% {
              background-position: -400px 0;
            }

            100% {
              background-position: 400px 0;
            }
          }
        `}
      </style>

      {/* Header */}

      <SectionHeader icon="🏆" title="Top 5 Sales Team Performance" />

      {/* Cards */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))",
          gap: 16,
        }}
      >
        {data.map((item, index) => (
          <PerformanceCard
            key={item.id}
            item={item}
            rank={index + 1}
            onInfo={() => setSelectedUser(item)}
          />
        ))}
      </div>

      {/* Popup */}

      {selectedUser && (
        <UserPopup user={selectedUser} onClose={() => setSelectedUser(null)} />
      )}
    </>
  );
}

/* -------------------------------------------------------------------------- */
/*                             Performance Card                               */
/* -------------------------------------------------------------------------- */

function PerformanceCard({ item, rank, onInfo }) {
  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #E2E8F0",
        borderRadius: 18,
        padding: 20,
        position: "relative",
        overflow: "hidden",
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-4px)";

        e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.08)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "none";

        e.currentTarget.style.boxShadow = "none";
      }}
    >
      {/* Rank */}

      <div
        style={{
          position: "absolute",
          top: 14,
          right: 14,
          background:
            rank <= 3 ? "linear-gradient(135deg,#F59E0B,#FBBF24)" : "#E2E8F0",
          color: rank <= 3 ? "#fff" : "#334155",
          width: 34,
          height: 34,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 800,
          fontSize: 13,
        }}
      >
        #{rank}
      </div>

      {/* Profile */}

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 14,
          marginBottom: 18,
        }}
      >
        {/* Avatar */}

        <div
          style={{
            width: 58,
            height: 58,
            borderRadius: "50%",
            background: "linear-gradient(135deg,#2563EB,#7C3AED)",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 800,
            fontSize: 18,
            flexShrink: 0,
          }}
        >
          {item.avatar}
        </div>

        {/* Details */}

        <div>
          <div
            style={{
              fontSize: 16,
              fontWeight: 800,
              color: "#0F172A",
            }}
          >
            {item.name}
          </div>

          <div
            style={{
              marginTop: 4,
              fontSize: 13,
              color: "#64748B",
              fontWeight: 600,
            }}
          >
            {item.designation}
          </div>
        </div>
      </div>

      {/* Joining Date */}

      <div
        style={{
          fontSize: 12,
          color: "#64748B",
          marginBottom: 14,
        }}
      >
        📅 Joined: {item.joiningDate}
      </div>

      {/* Sales */}

      <div
        style={{
          marginBottom: 16,
        }}
      >
        <div
          style={{
            fontSize: 12,
            color: "#94A3B8",
            marginBottom: 6,
            fontWeight: 600,
          }}
        >
          Total Sales
        </div>

        <div
          style={{
            fontSize: 28,
            fontWeight: 800,
            color: "#2563EB",
          }}
        >
          ₹ {item.sales.toLocaleString()}
        </div>
      </div>

      {/* Target */}

      <div
        style={{
          marginBottom: 18,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 6,
          }}
        >
          <span
            style={{
              fontSize: 12,
              color: "#64748B",
              fontWeight: 600,
            }}
          >
            Target Achievement
          </span>

          <span
            style={{
              fontSize: 12,
              color: "#16A34A",
              fontWeight: 700,
            }}
          >
            {item.target}%
          </span>
        </div>

        <div
          style={{
            height: 8,
            borderRadius: 999,
            background: "#E2E8F0",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              width: `${item.target}%`,
              height: "100%",
              background: "linear-gradient(90deg,#10B981,#34D399)",
              borderRadius: 999,
            }}
          />
        </div>
      </div>

      {/* Footer */}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* Growth */}

        <div
          style={{
            background: "#DCFCE7",
            color: "#16A34A",
            padding: "6px 10px",
            borderRadius: 999,
            fontSize: 12,
            fontWeight: 700,
          }}
        >
          ↑ {item.growth}% Growth
        </div>

        {/* Info */}

        <button
          onClick={onInfo}
          style={{
            border: "none",
            background: "#EFF6FF",
            color: "#2563EB",
            width: 34,
            height: 34,
            borderRadius: "50%",
            cursor: "pointer",
            fontWeight: 800,
            fontSize: 15,
          }}
        >
          i
        </button>
      </div>
    </div>
  );
}

/* -------------------------------------------------------------------------- */
/*                                User Popup                                  */
/* -------------------------------------------------------------------------- */
function UserPopup({ user, onClose }) {
  const kriData = [
    {
      label: "Target Hit",
      val: 92,
      color: "#7BC8A4",
    },

    {
      label: "Attendance",
      val: 96,
      color: "#8FB8ED",
    },

    {
      label: "Outlet Coverage",
      val: 84,
      color: "#D4A373",
    },

    {
      label: "Productivity",
      val: 89,
      color: "#B9A7F5",
    },

    {
      label: "GPS Accuracy",
      val: 98,
      color: "#E28B84",
    },
  ];

  return (
    <>
      {/* Overlay */}

      <div
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(148,163,184,0.18)",
          zIndex: 999,
          backdropFilter: "blur(4px)",
        }}
      />

      {/* Popup */}

      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
          width: 760,
          background: "#FCFDFE",
          borderRadius: 22,
          padding: 28,
          zIndex: 1000,
          border: "1px solid #E6ECF3",
          boxShadow: "0 10px 30px rgba(15,23,42,0.08)",
        }}
      >
        {/* Header */}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 24,
          }}
        >
          <div
            style={{
              display: "flex",
              gap: 14,
              alignItems: "center",
            }}
          >
            {/* Avatar */}

            <div
              style={{
                width: 64,
                height: 64,
                borderRadius: "50%",
                background: "linear-gradient(135deg,#8FB8ED,#B9A7F5)",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 800,
                fontSize: 20,
              }}
            >
              {user.avatar}
            </div>

            {/* Details */}

            <div>
              <div
                style={{
                  fontSize: 20,
                  fontWeight: 800,
                  color: "#334155",
                }}
              >
                {user.name}
              </div>

              <div
                style={{
                  marginTop: 4,
                  color: "#8A94A6",
                  fontSize: 13,
                  fontWeight: 600,
                }}
              >
                {user.designation}
              </div>
            </div>
          </div>

          {/* Close */}

          <button
            onClick={onClose}
            style={{
              border: "none",
              background: "#F5F7FA",
              width: 34,
              height: 34,
              borderRadius: "50%",
              cursor: "pointer",
              fontWeight: 700,
              color: "#7B8794",
            }}
          >
            ✕
          </button>
        </div>

        {/* Body */}

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 320px",
            gap: 22,
          }}
        >
          {/* LEFT SIDE */}

          <div
            style={{
              background: "#F8FAFC",
              border: "1px solid #EEF2F7",
              borderRadius: 18,
              padding: 22,
            }}
          >
            {/* Title */}

            <div
              style={{
                fontSize: 12,
                fontWeight: 700,
                color: "#94A3B8",
                textTransform: "uppercase",
                letterSpacing: "0.06em",
                marginBottom: 18,
              }}
            >
              Employee Details
            </div>

            {/* Info */}

            <InfoRow label="Employee Code" value={user.employeeCode} />

            <InfoRow label="Region" value={user.region} />

            <InfoRow label="Joining Date" value={user.joiningDate} />

            <InfoRow label="Phone" value={user.phone} />

            <InfoRow label="Email" value={user.email} />

            <InfoRow label="Sales" value={`₹ ${user.sales.toLocaleString()}`} />

            <InfoRow label="Growth" value={`${user.growth}%`} />

            <InfoRow label="Target Achievement" value={`${user.target}%`} />
          </div>

          {/* RIGHT SIDE */}

          <div
            style={{
              background: "#F8FAFC",
              border: "1px solid #EEF2F7",
              borderRadius: 18,
              padding: "20px 22px",
            }}
          >
            {/* Title */}

            <div
              style={{
                fontSize: 12,
                fontWeight: 700,
                color: "#94A3B8",
                textTransform: "uppercase",
                letterSpacing: "0.06em",
                marginBottom: 20,
              }}
            >
              Performance KRI
            </div>

            {/* KRI Items */}

            {kriData.map((item) => (
              <div
                key={item.label}
                style={{
                  marginBottom: 18,
                }}
              >
                {/* Header */}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 8,
                  }}
                >
                  <span
                    style={{
                      fontSize: 13,
                      color: "#64748B",
                      fontWeight: 600,
                    }}
                  >
                    {item.label}
                  </span>

                  <span
                    style={{
                      fontSize: 13,
                      fontWeight: 700,
                      color: item.color,
                    }}
                  >
                    {item.val}%
                  </span>
                </div>

                {/* Progress */}

                <div
                  style={{
                    height: 8,
                    background: "#E8EEF5",
                    borderRadius: 999,
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      width: `${item.val}%`,
                      height: "100%",
                      background: item.color,
                      borderRadius: 999,
                      transition: "width 1s ease",
                      boxShadow: `0 0 10px ${item.color}40`,
                    }}
                  />
                </div>
              </div>
            ))}

            {/* Overall */}

            <div
              style={{
                marginTop: 24,
                paddingTop: 18,
                borderTop: "1px solid #EEF2F7",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 8,
                }}
              >
                <span
                  style={{
                    fontSize: 13,
                    color: "#64748B",
                    fontWeight: 700,
                  }}
                >
                  Overall Performance
                </span>

                <span
                  style={{
                    fontSize: 13,
                    color: "#69B48F",
                    fontWeight: 800,
                  }}
                >
                  92%
                </span>
              </div>

              <div
                style={{
                  height: 10,
                  background: "#E8EEF5",
                  borderRadius: 999,
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    width: "92%",
                    height: "100%",
                    background: "linear-gradient(90deg,#7BC8A4,#A8E6CF)",
                    borderRadius: 999,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

/* -------------------------------------------------------------------------- */
/*                                 Info Row                                   */
/* -------------------------------------------------------------------------- */

function InfoRow({ label, value }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "12px 0",
        borderBottom: "1px solid #F1F5F9",
      }}
    >
      <span
        style={{
          fontSize: 13,
          color: "#64748B",
          fontWeight: 600,
        }}
      >
        {label}
      </span>

      <span
        style={{
          fontSize: 13,
          color: "#0F172A",
          fontWeight: 700,
        }}
      >
        {value}
      </span>
    </div>
  );
}

/* -------------------------------------------------------------------------- */
/*                               Section Header                               */
/* -------------------------------------------------------------------------- */

function SectionHeader({ icon, title }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        marginBottom: 14,
        marginTop: 32,
        paddingBottom: 10,
        borderBottom: "1.5px solid #F1F5F9",
      }}
    >
      <span
        style={{
          fontSize: 20,
        }}
      >
        {icon}
      </span>

      <span
        style={{
          fontSize: 13,
          fontWeight: 700,
          letterSpacing: "0.08em",
          textTransform: "uppercase",
          color: "#475569",
        }}
      >
        {title}
      </span>
    </div>
  );
}

/* -------------------------------------------------------------------------- */
/*                               Skeleton Loader                              */
/* -------------------------------------------------------------------------- */

function TopSalesPerformersSkeleton() {
  return (
    <>
      <style>
        {`
          @keyframes shimmer {
            0% {
              background-position: -400px 0;
            }

            100% {
              background-position: 400px 0;
            }
          }
        `}
      </style>

      <SectionHeader icon="🏆" title="Top 5 Sales Team Performance" />

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))",
          gap: 16,
        }}
      >
        {[1, 2, 3, 4, 5].map((i) => (
          <SkeletonCard key={i} />
        ))}
      </div>
    </>
  );
}

function SkeletonCard() {
  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #E2E8F0",
        borderRadius: 18,
        padding: 20,
      }}
    >
      {/* Profile */}

      <div
        style={{
          display: "flex",
          gap: 14,
          marginBottom: 20,
        }}
      >
        <SkeletonCircle size={58} />

        <div style={{ flex: 1 }}>
          <SkeletonLine width="70%" height={14} />

          <div style={{ marginTop: 10 }}>
            <SkeletonLine width="50%" height={10} />
          </div>
        </div>
      </div>

      {/* Date */}

      <SkeletonLine width="55%" height={10} />

      {/* Sales */}

      <div style={{ marginTop: 22 }}>
        <SkeletonLine width="40%" height={10} />

        <div style={{ marginTop: 10 }}>
          <SkeletonLine width="60%" height={30} />
        </div>
      </div>

      {/* Progress */}

      <div style={{ marginTop: 24 }}>
        <SkeletonLine width="100%" height={8} />
      </div>

      {/* Footer */}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: 22,
        }}
      >
        <SkeletonLine width="90px" height={28} />

        <SkeletonCircle size={34} />
      </div>
    </div>
  );
}

function SkeletonLine({ width, height }) {
  return (
    <div
      style={{
        width,
        height,
        borderRadius: 999,
        background: "linear-gradient(90deg,#E2E8F0,#F8FAFC,#E2E8F0)",
        backgroundSize: "800px 100%",
        animation: "shimmer 1.5s infinite linear",
      }}
    />
  );
}

function SkeletonCircle({ size }) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        background: "linear-gradient(90deg,#E2E8F0,#F8FAFC,#E2E8F0)",
        backgroundSize: "800px 100%",
        animation: "shimmer 1.5s infinite linear",
      }}
    />
  );
}
